import * as actionTypes from "../../../constants/actionTypes";
import {getApiConfig} from "../../../utilities";

export const toggleShowJobBoardFiltersPopup = (showJobBoardFiltersPopup) => ({
  type: actionTypes.JOB_BOARD_SHOW_FILTERS_POPUP,
  payload: {showJobBoardFiltersPopup}
})

export const getStoresAndEmployees = () => {
  return (dispatch, getState) => {
    // dispatch(loadingDialog_show(true, "Loading...", "Receiving list data, please wait..."));
    const {get} = getApiConfig('JobBoard');
    return get('/GetSalesAndStores')
      .then((response) => {
        const sales = response.salesPeople.filter(people => people);
        const stores = response.stores.filter(store => store);
        dispatch(setFiltersPopupResponse(true, sales, stores));
        // dispatch(loadingDialog_show(false));
        return response
      })
      .catch((error) => {
        dispatch(setFiltersPopupResponse());
        console.error(error);
      })
  }
}

export const setFiltersPopupResponse = (filtersPopupResponseReceived = true,
                                        filtersPopupSalesPersons = [],
                                        filtersPopupStores = []) => ({
  type: actionTypes.JOB_BOARD_SET_FILTERS_POPUP_RESPONSE,
  payload: {filtersPopupResponseReceived, filtersPopupSalesPersons, filtersPopupStores}
})
